var _ellipse, _ellipse2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 739,
    viewBox: "0 0 363 739",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181,
    cy: 253,
    rx: 181,
    ry: 181,
    transform: "rotate(90 181 253)",
    fill: "#1D41FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181,
    cy: 483,
    rx: 181,
    ry: 181,
    transform: "rotate(90 181 483)",
    fill: "#1D41FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7241 368.607C74.925 408.561 124.992 434 181 434C237.573 434 288.085 408.045 321.276 367.393C288.075 327.439 238.008 302 182 302C125.426 302 74.9151 327.955 41.7241 368.607Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.998 188.5C82.3107 188.5 1.49807 107.687 1.49807 8C1.49807 -91.6874 82.3107 -172.5 181.998 -172.5C281.685 -172.5 362.498 -91.6874 362.498 8.00002C362.498 107.687 281.685 188.5 181.998 188.5Z",
    stroke: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.998 909.5C82.3107 909.5 1.49807 828.687 1.49807 729C1.49807 629.313 82.3107 548.5 181.998 548.5C281.685 548.5 362.498 629.313 362.498 729C362.498 828.687 281.685 909.5 181.998 909.5Z",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.218e2670ed0fb5e74f5532da189f99aa.svg";
export { ForwardRef as ReactComponent };